import { Component, computed, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { PensionsudbydereService } from '../pensionsudbydere.service';
import { PuSearchParams } from './pu-search-params.model';
import { Button } from 'primeng/button';
import { InputText } from 'primeng/inputtext';
import { Message } from 'primeng/message';

@Component({
  selector: 'app-pu-search',
  imports: [ReactiveFormsModule, CheckboxModule, Button, InputText, Message],
  templateUrl: './pu-search.component.html',
  styleUrl: './pu-search.component.css',
})
export class PuSearchComponent {
  puService = inject(PensionsudbydereService);
  data = this.puService.datasource.data;

  form = new FormGroup({
    navn: new FormControl(),
    regnr: new FormControl(),
  });

  onClickSearch() {
    this.puService.searchPu({
      ...(this.form.value as PuSearchParams),
      searchTime: new Date(),
    });
  }

  onClickReset() {
    this.form.setValue({
      navn: null,
      regnr: null,
    });
  }

  noHits = computed(() => {
    return (
      this.puService.datasource.isLoaded() && this.data()?.totalRowCount == 0
    );
  });
}
